export default "__VITE_ASSET__a3974ac5__"